export const VisitTypes = [
  { id: 1, label: "Daily" },
  { id: 2, label: "Weekly" },
  { id: 3, label: "Monthly" },
];

export const careerAssignedOptions = [
  { id: "true", name: "Career Assigned" },
  { id: "false", name: "Career Not Assigned" },
];
